import { formaters } from "vincent-utils";
import moment from "moment";
const getAgeFromDdn = (ddnString, now) => {
    return getDecimalAgeFromAgeObject(getAgeObject(ddnString, now) || { mois: 0, annees: 0 });
};
const getAgeObject = (ddnString, now) => {
    return formaters.getAgeFromDDN(moment(ddnString, "DD/MM/YYYY").toDate(), now);
};
const getDecimalAgeFromAgeObject = (ageObject) => ageObject.mois / 12 + ageObject.annees;
export { getAgeFromDdn };
//# sourceMappingURL=age.js.map